import { useEffect, useState } from 'react';

import { useGlobalDialog } from "../../Store/DialogManager";

import { useSnackbar } from "notistack";
import styled from 'styled-components';
import { TableContainer } from '../../Styles/CustomViews/Pages/ListComponent/customListComponentStyles';
import { IconPlus } from '@tabler/icons-react';

// import { useCompanyHook } from '../../Hooks/Companies/companyHooks';
import { useLicenseHook } from '../../Hooks/License/licenseHooks';

import { RenewLicenseModalInterface } from '../../Models/Company/Company';
import { LicenseList } from '../../Models/License/License';

import QueryBuilderHelper from '../../Utilities/Helpers/QueryBuilderHelper';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import { CachingEnum } from '../../Utilities/Enums/CachingEnum';
import { LicenseField, LicenseListField } from '../../Utilities/Enums/ParametersEnum';
import { LicenseStatusEnum } from '../../Utilities/Enums/StatusEnums';
import { ValidityType } from '../../Utilities/Enums/ValidityTypeEnums';
import { OrderByEnum } from '../../Utilities/Enums/SortEnums';

import { ErrorMessage } from '../../Constants/Messages';

import CustomButton from '../../CustomViews/Elements/CustomButton';
import CustomListComponent from '../../CustomViews/Pages/ListComponent/CustomListComponent';
import CustomExpirationDate from '../../CustomViews/Elements/CustomExpirationDate';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    width: 60vw;
`;

export default function RenewLicenseModal(props: RenewLicenseModalInterface) {
    let { openRenewLicenseModal, setopenRenewLicenseModal, companyPublicId, getCompanyData } = props;
    const { enqueueSnackbar } = useSnackbar();
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();

    //Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
        status: LicenseStatusEnum.UNUSED,
        companyPublicId: companyPublicId,
        sortBy: QueryBuilderHelper.DefaultSortValue(LicenseListField.LICENSE_KEY),
        orderBy: QueryBuilderHelper.DefaultOrderValue(OrderByEnum.DESC),
    });

    const q_queryKey = [CachingEnum.LICENSES, queryStr];
    const { data, fetchStatus, assignLicenseById } = useLicenseHook(q_queryKey, queryStr);

    const tableColumns = [
        {
            accessor: LicenseListField.LICENSE_KEY,
            title: 'License Key',
            sortable: true,
        },
        {
            accessor: LicenseListField.USER_CAPACITY,
            title: 'No. Of Users',
            sortable: true,
        },
        {
            accessor: LicenseListField.STORAGE_CAPACITY,
            title: 'Data Storage',
            sortable: true,
            render: (record: LicenseList) => (record?.[LicenseListField.STORAGE_CAPACITY] ?? "0") + " GB"
        },
        {
            accessor: LicenseListField.VALIDITY,
            title: 'Validity',
            sortable: true,
            render: (record: LicenseList) => (record?.[LicenseListField.VALIDITY] ?? "0") + " " + (ValidityType?.[record?.[LicenseListField.VALIDITY_TYPE]]?.title ?? "Month") + "(s)",
        },
        {
            accessor: LicenseListField.EXPIRY_DATE,
            title: 'Expiry Date',
            sortable: true,
            render: (record: LicenseList) => <CustomExpirationDate expiryDate={record?.[LicenseListField.EXPIRY_DATE] ?? null} />
        },
        {
            accessor: 'action',
            title: "Action",
            render: (record: LicenseList) => <>
                <CustomButton
                    btnType={ButtonType.PRIMARY}
                    title='Apply'
                    startIcon={<IconPlus />}
                    onClick={(e: any) => {
                        assignLicense(record?.[LicenseListField.PUBLIC_ID] ?? "");
                    }} />
            </>
        },
    ];

    //Event Handlers
    const assignLicense = async (licensePublicId: string | number) => {
        let _success: boolean = false;

        if(companyPublicId && licensePublicId) {
            let allocateResponse = await assignLicenseById(licensePublicId, JSON.stringify({[LicenseField.COMPANY_PUBLIC_ID]: companyPublicId}));

            _success = allocateResponse?.isSuccess ?? false;
        } else {
            enqueueSnackbar(ErrorMessage.PROBLEM_ASSIGNING_LICENSE, { variant: 'error' });
        }

        if(_success) {
            if(getCompanyData) {
                getCompanyData();
            }

            onCloseDialog();
        }
    }

    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenRenewLicenseModal) {
            setopenRenewLicenseModal(false);
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openRenewLicenseModal) {
            setDialogContent({
                title: "Available License Key",
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                children: renderDialogContent(),
            });
        }
    }, [openRenewLicenseModal, fetchStatus, data]);

    //Rendering Functions
    const renderDialogContent = () => {
        return <ModalContentContainer>
            <TableContainer>
                <CustomListComponent
                    fetching={fetchStatus == "fetching"}
                    columns={tableColumns}
                    idAccessor={(record: LicenseList) => `license${record?.[LicenseListField.PUBLIC_ID]}`}
                    records={data?.data?.list ?? []}
                    totalRecords={data?.data?.metaData?.totalCount ?? 0}
                    page={queryStr.pageNumber}
                    recordsPerPage={queryStr.pageSize}
                    defaultColumnSort={{ columnAccessor: queryStr?.sortBy ?? 'id', direction: queryStr?.orderBy ?? 'asc' }}
                    onSortStatusChange={((sort: any) => { setQueryStr((prev: any) => ({ ...prev, sortBy: sort?.columnAccessor ?? "id", orderBy: sort?.direction ?? "asc", pageNumber: 1 })) })}
                    setPage={(p: number) => setQueryStr((prev: any) => ({ ...prev, pageNumber: p }))}
                    onRecordsPerPageChange={(p: number) => setQueryStr((prev: any) => ({ ...prev, pageSize: p, pageNumber: 1 }))} />
            </TableContainer>
        </ModalContentContainer>
    }

    return <></>
}